import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ColorColumns } from './color-table.interface';

@Component({
  selector: 'app-color-table',
  templateUrl: './color-table.component.html',
  styleUrls: ['./color-table.component.scss']
})
export class ColorTableComponent implements OnInit {

  ngOnInit(): void {

  }
  @Input() DataLoading: boolean = false
  WCColors = ["c584d3", "a084d2", "60a5e8", "60d9d9", "5ce7a1", "aae272", "fce153", "f8c459", "febc5a", "eb8a5b"];
  @Input() columns: ColorColumns[] = [];
  @Input() tableData: any[] = [];
  @Input() enableCheckboxColumn: boolean = false;
  @Input() toggleStatus: boolean = false;
  @Input() checkboxColumnLabel: string = 'Select';
  @Input() enableActionColumn: boolean = false;
  @Input() actionColumnLabel: string = 'Actions';
  @Input() actionOptions: { actionName: string, actionIcon: string, action?: 'enable' | 'disable' }[] = [];
  @Input() checkboxStateBinding: string = 'isActive';
  @Input() enableBadge: string = ''
  @Input() enableInlineButton: { buttonName: string, buttonClass: string, actionHandler: (rowData: any) => void, isLoading?: boolean } | null = null;
  @Input() enableAutoSerial: boolean = false
  @Input() actionColumnPosition: 'left' | 'right' = 'right';
  @Output() selectionCheckBoxEvent: EventEmitter<{ checkstate: boolean, data: any }> = new EventEmitter()
  @Input() EnableMultiSelect: boolean = false
  // @Input() routeOption : {enable:boolean,route:string,colName: string,col}
  masterSelected: boolean = false;

  get totalColumnCount(): number {
    return (this.EnableMultiSelect ? 1 : 0)
      + (this.enableActionColumn ? 1 : 0)
      + (this.enableAutoSerial ? 1 : 0)
      + this.columns.length
      + (this.enableInlineButton ? 1 : 0)
      + (this.enableCheckboxColumn ? 1 : 0);
  }
  @Output() checkboxChange: EventEmitter<{ rowData: any, isChecked: boolean }> = new EventEmitter<{ rowData: any, isChecked: boolean }>();
  @Output() actionClick: EventEmitter<
    { actionName: string, rowData: any, action?: string }
  > = new EventEmitter<
    { actionName: string, rowData: any, action?: string }>();


  onCheckboxChange(row: any) {
    const isChecked = row[this.checkboxStateBinding];
    const rowData = row
    this.checkboxChange.emit({ rowData, isChecked });
  }


  /** Row action menu: placed `fixed` under (or above) its button, so the sideways-scrolling wrapper does not clip it
   *  (same as app-uic-color-table's positionDropdown). */
  positionDropdown(event: MouseEvent): void {
    const btn = event.currentTarget as HTMLElement;
    setTimeout(() => {
      const menu = btn.closest('.btn-group')?.querySelector('.dropdown-menu') as HTMLElement | null;
      if (!menu || !menu.classList.contains('show')) return;
      const rect = btn.getBoundingClientRect();
      const menuHeight = menu.offsetHeight || 200;
      const top = (window.innerHeight - rect.bottom) >= menuHeight
        ? rect.bottom
        : rect.top - menuHeight;
      Object.assign(menu.style, {
        position: 'fixed',
        inset: 'auto',
        top: top + 'px',
        left: rect.left + 'px',
        transform: 'none',
        zIndex: '9999',
        margin: '0',
      });
    }, 0);
  }

  actionButtonClick(actionName: any, rowData: any) {
    this.actionClick.emit({ actionName, rowData });
  }

  getLowerCaseValue(row: any, colKey: string) {
    const lowerCaseKey = colKey.toLowerCase();
    const matchingKey = Object.keys(row).find(key => key.toLowerCase() === lowerCaseKey);
    return matchingKey ? row[matchingKey] : null;
  }


  onSelctionCheckboxChange(event: any, rowdata: any) {
    console.log(event?.target.checked);
    console.log(rowdata);
    this.selectionCheckBoxEvent.emit({ checkstate: event?.target.checked, data: rowdata })

  }

  toggleSelectAll() {
    this.tableData.forEach(row => {
      row.isSelected = this.masterSelected;
      this.selectionCheckBoxEvent.emit({ checkstate: this.masterSelected, data: row });
    });
  }
  

}
